import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	globalShortcuts: {
		id: 'keyboard-shortcuts.global-shortcuts',
		defaultMessage: 'Global shortcuts',
		description: '',
	},
	quickSearch: {
		id: 'keyboard-shortcuts.quick-search',
		defaultMessage: 'Quick search',
		description: '',
	},
	closeDrawer: {
		id: 'keyboard-shortcuts.close-drawer',
		defaultMessage: 'Close drawer',
		description: '',
	},
	createIssue: {
		id: 'keyboard-shortcuts.create-issue',
		defaultMessage: 'Create issue',
		description: '',
	},
	keyboardShortcuts: {
		id: 'keyboard-shortcuts.keyboard-shortcuts',
		defaultMessage: 'Keyboard shortcuts',
		description: '',
	},
	keyboardShortcutsCommandPalette: {
		id: 'keyboard-shortcuts.keyboard-shortcuts-command-palette',
		defaultMessage: 'View keyboard shortcuts',
		description:
			'Command in the command palette which triggers the modal that displays all keyboard shortcuts',
	},
	findIssues: {
		id: 'keyboard-shortcuts.find-issues',
		defaultMessage: 'Find issues',
		description: '',
	},
	browseAProject: {
		id: 'keyboard-shortcuts.browse-a-project',
		defaultMessage: 'Browse to a project',
		description: '',
	},
	toggleSidebar: {
		id: 'keyboard-shortcuts.toggle-sidebar',
		defaultMessage: 'Toggle sidebar',
		description: '',
	},
	openHelpPanel: {
		id: 'keyboard-shortcuts.open-help-panel',
		defaultMessage: 'Open help panel',
		description: 'Description of the keyboard shortcut to open the help-panel',
	},
	openCommandPalette: {
		id: 'keyboard-shortcuts.open-command-palette',
		defaultMessage: 'Open command palette',
		description: 'Description of the keyboard shortcut to open the command palette',
	},
	quickSearchCommand: {
		id: 'keyboard-shortcuts.quick-search-command',
		defaultMessage: 'Open quick search',
		description:
			'Command in the command palette that will trigger that will focus the user in the quick search input',
	},
	getHelp: {
		id: 'keyboard-shortcuts.get-help',
		defaultMessage: 'Get help',
		description: 'Command in the command palette that will trigger the help panel on the sidebar',
	},
	viewAllIssues: {
		id: 'keyboard-shortcuts.view-all-issues',
		defaultMessage: 'View all issues',
		description:
			'Command in the command palette that will navigate the user to the advanced issue search',
	},
});
